<template>
	<div>
		<dl class="opport-screen bdbe">
			<dt class="fl">{{curWebsite.type == 5 || curWebsite.type == 10 ? '投资':"产业"}}动态</dt>
			<dd class="fl">
				<el-tooltip class="item smartTip-text" effect="light" placement="top-start">
					<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
					<div slot="content" class="list_tips"> 
						<p>创新企业融资：最新一年创新企业的融资动态</p> 
						<p>专业机构投资：有投资行为的重点专业投资机构</p>
						<p>上市公司投资：最近一年A股上市公司的投资动态</p>
						<!-- <p>优质上市公司招商：上市公司名单，可以通过各种指标筛选</p> -->
						<p>企业拿地投资：最近一年龙头企业拿地投资动态</p>
						<!-- <p>行业投资动态：xxxxxx</p> -->
						<p>企业投资窗口期：投资意愿强，处于投资窗口期的企业名单</p>
						<p>产业投资窗口期：发展潜力大、处于投资窗口期的产业及相关企业</p> 
					</div>
				</el-tooltip>
				<span :key="index" v-for="(item,index) in listd" @click="routerself(item.url)"
					:class="item.code == code ?'a-screen current':'a-screen'">{{item.name}} </span> 
			</dd>
		</dl> 
	</div>
</template>

<script>
	export default {
		name: 'dynamic-nav',//产业投资大脑和产业研究大脑使用的产业动态跟踪
		props: {
			searchtype: {
				type: Number,
				default: 0,
			},
			code:{
				type:String,
				default:"",
			},
			showTime:{
				type:Boolean,
				default:false, 
			}
		},
		data: function() {
			return {
				iszsdn: this.$api.iszsdn(),
				curWebsite:this.$api.getWebsiteType(),
				xstext: "",
				websittype: '产业投资大脑',
				datetype: '',
				finantime: '',
				curNav:{},
				userdata:{},
				listd: [
					{
						url: "/investment-clues3",
						name: "创新企业融资动态",
						keyword: "融资",
						tips: "融资时间：最近一年获得融资的创新企业",
						code:'cxqyrz',
					},
					// {
					// 	url: "/investment-institutions",
					// 	name: "专业机构投资动态",
					// 	keyword: "投资",
					// 	tips: "投资时间：最近一年投资的专业机构",
					// 	code:"zyjgtz",
					// },
					{
						url: "/markenterprise",
						name: "上市公司投资动态",
						keyword: "投资",
						tips: "投资时间：最近一年投资的标杆企业",
						code:'ssgstz',
					},
					{
						url: "/landenterprise",
						name: "企业拿地投资动态",
						keyword: "拿地",
						tips: "拿地时间：最近一年拿地的龙头企业",
						code:'qyndtz',
					},
					{
						url: "/industryInvestment",
						name: "产业资讯动态",
						keyword: "投资",
						tips: "",
						code:"hydttz",
					},
					{
							url: "/enterpriseInvestmentWindow",
							name: "企业投资窗口期",
							keyword: "投资",
							tips: "",
							code:'qytzck',
						},
						{
								url: "/industryInvestmentWindow",
								name: "产业投资窗口期",
								keyword: "投资",
								tips: "",
								code:'cytzck',
							},
				], 
			};
		},
		created() { 
			console.log('用户类型', this.searchtype); 
		},
		watch: {
			searchtype: {
				handler(newVal, oldVal) {
					this.type = newVal;
					document.title = this.websittype + "-" + this.listd[this.searchtype - 1].name ;
				}
			},
			code:{
				handler(newVal, oldVal) {
					this.type = newVal;
				 this.getcurNav(this.code);
				}
			}, 


		},
		mounted() {
			this.userdata = this.getuseriformation();
			this.getcurNav(this.code);
		},
		methods: {
			getcurNav(code){
				if( !this.userdata.token  || this.userdata.groupType != 1){
					this.listd = this.listd.filter(item => item.name != '产业资讯动态');
				}
				let adb=this.listd.filter(list=>{
					return list.code == code;
				});
				this.curNav=adb[0];
				document.title = this.curNav.name  + "-" + this.websittype;
			},
			send(time1,time2) {
				this.finantime = time1;
				this.$emit('receive', time1,time2);
			}
		}
	}
</script>

<style>
	.a-red {
		color: #c00;
	}
</style>